export default "__VITE_ASSET__936356db__"